<script setup lang="ts">
import SettingsCard from '@/components/organisms/SettingsCard.vue';
import Auth from './Auth.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import AddressBookMenu from '@/components/layout/AddressBookMenu.vue';
import AppSearch from '@/components/molecules/AppSearch.vue';
import { useAddressBookStore } from '@/store/addressBook';
const route = useRoute();

const isHome = computed(() => route.name === 'Home');
const book = useAddressBookStore();

const displayAddressBook = computed(() => {
  if (!isHome.value) return true;
  const isEmpty = book.items.length === 0 && book.bundles.length === 0;
  return !isEmpty;
});
</script>

<template>
  <v-app-bar
    :border="true"
    flat
    style="border-top-width: 0; border-left-width: 0; border-right-width: 0"
  >
    <v-container class="flex flex-row align-center gap-2">
      <router-link :to="{ name: 'Home' }">
        <div class="gap-3 flex items-center">
          <img
            height="24px"
            src="/logo.svg"
            alt="Jupiter Portfolio logo"
            class="h-[24px]"
          />
          <p class="font-bold text-base max-sm:hidden">Jupiter</p>
        </div>
      </router-link>

      <div class="flex flex-row gap-2 items-center w-full justify-end">
        <app-search v-if="!isHome" class="max-w-[200px]"></app-search>
        <v-btn v-if="displayAddressBook" size="40" variant="tonal" icon>
          <v-icon icon="mdi-book-alphabet" size="18"></v-icon>
          <address-book-menu />
        </v-btn>
        <v-btn size="40" variant="tonal" icon v-if="!isHome">
          <v-icon icon="mdi-cog" size="18"></v-icon>
          <v-menu
            activator="parent"
            location="bottom end"
            transition="false"
            :close-on-content-click="false"
          >
            <settings-card />
          </v-menu>
        </v-btn>

        <Auth v-if="!isHome" />
      </div>
    </v-container>
  </v-app-bar>
</template>
